import { render } from "./SurveyEmotionQuestion.vue?vue&type=template&id=5ca766be&scoped=true"
import script from "./SurveyEmotionQuestion.vue?vue&type=script&lang=js"
export * from "./SurveyEmotionQuestion.vue?vue&type=script&lang=js"

import "./SurveyEmotionQuestion.vue?vue&type=style&index=0&id=5ca766be&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ca766be"]])

export default __exports__